import React from "react";
import CalendarMain from "../../component/PerpetualCalendar/CalendarMain";

const CalendarPerpetual: React.FC = () => {
  return (
    <>
      <CalendarMain />
    </>
  );
};
export default CalendarPerpetual;
